"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionProfileSchema = exports.BankDetailSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const TAX_RESIDENCY_INVALID = "Invalid tax residency code, must be 3 letters";
const PREFERENCE_INVALID = "Distribution preference must be 'payout' or 'reinvest'";
const BANK_COUNTRY_UNSUPPORTED = "Bank account country is not supported";
const emptyToUndefined = (value) => (value === "" || value === null ? undefined : value);
const COMPACTED_BANK_FIELDS = new Set(["iban", "swiftBic"]);
/**
 * A bank field whose required flag and pattern come from the account country's rules. A field the
 * country does not collect is left unchecked; the API drops it before saving.
 */
const bankField = (field) => {
    const base = yup.string().trim().transform(emptyToUndefined);
    const compacted = COMPACTED_BANK_FIELDS.has(field)
        ? base.transform((value) => value?.replace(/\s+/g, "").toUpperCase())
        : base;
    return compacted.when("country", ([country], schema) => {
        const rule = (0, mystake_common_sdk_1.getInvestorBankCountry)(country)?.fields.find((candidate) => candidate.field === field);
        if (!rule)
            return schema.optional();
        let ruled = rule.required ? schema.required(`${rule.label} is required`) : schema.optional();
        if (rule.pattern)
            ruled = ruled.matches(rule.pattern, rule.patternMessage ?? `${rule.label} is invalid`);
        return ruled;
    });
};
exports.BankDetailSchema = yup.object().shape({
    country: yup
        .string()
        .trim()
        .transform(emptyToUndefined)
        .uppercase()
        .test("supported-bank-country", BANK_COUNTRY_UNSUPPORTED, (value) => !value || (0, mystake_common_sdk_1.isSupportedInvestorBankCountry)(value))
        .optional(),
    bankAccountName: bankField("bankAccountName"),
    bankName: bankField("bankName"),
    bankBSB: bankField("bankBSB"),
    routingCode: bankField("routingCode"),
    bankAccountNumber: bankField("bankAccountNumber"),
    iban: bankField("iban"),
    swiftBic: bankField("swiftBic"),
});
exports.DistributionProfileSchema = yup.object().shape({
    taxResidency: yup
        .string()
        .trim()
        .transform(emptyToUndefined)
        .uppercase()
        .length(3, TAX_RESIDENCY_INVALID)
        .test("valid-alpha3", TAX_RESIDENCY_INVALID, (value) => !value || mystake_common_sdk_1.COUNTRY_ALPHA3_CODES.has(value))
        .optional(),
    bankDetail: exports.BankDetailSchema.optional().default(undefined),
    distributionPreference: yup
        .string()
        .transform(emptyToUndefined)
        .oneOf(["payout", "reinvest"], PREFERENCE_INVALID)
        .optional(),
});
//# sourceMappingURL=DistributionProfile.js.map